import { createSlice } from '@reduxjs/toolkit';
import moment from 'moment/moment';

// const selectWebsocketConnected = (state) => state.websocket.websocketConnected;
// const selectHasWebsocketError = (state) => state.websocket.hasWebsocketError;
// const selectWebsocketConnectedTimestamp = (state) => state.websocket.connectedTimestamp;

const WebsocketSlice = createSlice({
  name: 'websocket',
  initialState: {
    websocketConnected: false,
    hasWebsocketError: false,
    autoRetry: false,
    connectedTimestamp: moment().unix(),
  },
  reducers: {
    setWebsocketConnected: (state, action) => {
      state.websocketConnected = action.payload;
      state.connectedTimestamp = moment().unix();
    },
    setWebsocketError: (state, action) => {
      state.hasWebsocketError = action.payload;
    },
    setWebsocketAutoRetry: (state, action) => {
      state.autoRetry = action.payload;
    },
    clearWebsocketSlice: (state) => {
      state.websocketConnected = false;
      state.hasWebsocketError = false;
      state.autoRetry = false;
    },
  },
});

const { actions, reducer } = WebsocketSlice;

export const {
  setWebsocketConnected, setWebsocketError, setWebsocketAutoRetry, clearWebsocketSlice,
} = actions;

export default reducer;
